module.exports = __webpack_public_path__ + "static/media/raycast_demo.01f2be88.jpg";